import { render, staticRenderFns } from "./card-coupon-item-new.vue?vue&type=template&id=46b17ae3&scoped=true&lang=pug&"
import script from "./card-coupon-item-new.vue?vue&type=script&lang=js&"
export * from "./card-coupon-item-new.vue?vue&type=script&lang=js&"
import style0 from "./card-coupon-item-new.vue?vue&type=style&index=0&id=46b17ae3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b17ae3",
  null
  
)

export default component.exports